import React from "react";

const BUTTON_HEIGHT = 30;

/**
 * Button for editing item code & description
 */
const EditItemCodeButton = ({ onClick, hasParts }) => {
  if (!hasParts) return null;

  return (
    <div style={{ marginTop: "24px" }}>
      <button
        style={{
          height: BUTTON_HEIGHT,
          backgroundColor: "white",
          borderRadius: "5px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          border: "2px solid #0056b3",
          color: "#0056b3",
          width: "100%",
          marginTop: "-10px",
          marginBottom: "10px",
        }}
        onClick={onClick}
      >
        Edit Item Code & Description
      </button>
    </div>
  );
};

export default EditItemCodeButton;
